import axios, {AxiosResponse} from 'axios'

// applicationLetterList
const applicationLetterList = async ({params}) => {
  const response = await axios.get('/api/application-letter/list', params)
  return response.data
}

// Edit applicationLetterEdit
const applicationLetterEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/application-letter/edit/${id}`)
  return response.data
}

// applicationLetterUpdate
const applicationLetterUpdate = async ({data}) => {
  await axios.post('/api/application-letter/update', data)
}

// applicationLetterTest
const applicationLetterTest = async (id: string) => {
  const res = await axios.get(`/api/application-letter/test/${id}`)
  return res.data
}

// List news
const newsList = async ({params}) => {
  const response = await axios.get('/api/news/list', params)
  return response.data
}

// Create Or Update news
const newsCreate = async ({data}) => {
  await axios.post('/api/news/store', data)
}

// Edit news
const newsEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/news/edit/${id}`)
  return response.data
}

// Delete news
const newsDelete = async (id: string) => {
  await axios.get(`/api/news/destroy/${id}`)
}

// Get Types
const getTypes = async (type: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/news/get-type/${type}`)
  return response.data
}

// newsToggle
const newsToggle = async (id: string) => {
  await axios.get(`/api/news/toggle/${id}`)
}

const newsDetails = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/news/view/${id}`)
  return response.data
}

// Get Types this is for lecturer to load only its content
const getNewsTypes = async (type: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/news/get-news-type/${type}`)
  return response.data
}

const newsToggleArchive = async (id: string) => {
  await axios.get(`/api/news/toggle-archive/${id}`)
}

const archivedNewsList = async ({params}) => {
  const response = await axios.get('/api/news/archived-list', params)
  return response.data
}

const formList = async ({params}) => {
  const response = await axios.get('/api/form/list', params)
  return response.data
}

const formCreate = async ({data}) => {
  const response = await axios.post('/api/form/store', data)
  return response.data
}

const formEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/form/edit/${id}`)
  return response.data
}

const formDelete = async (id: string) => {
  await axios.get(`/api/form/destroy/${id}`)
}

const stdAnnRep = async () => {
  const res = await axios.get(`/api/form/std-ann-rep`)
  return res.data
}

const almAnnRep = async () => {
  const res = await axios.get(`/api/form/alm-ann-rep`)
  return res.data
}

const lecAnnRep = async () => {
  const res = await axios.get(`/api/form/lec-ann-rep`)
  return res.data
}

const adminService = {
  stdAnnRep,
  almAnnRep,
  lecAnnRep,
  formList,
  formCreate,
  formEdit,
  formDelete,
  newsToggleArchive,
  archivedNewsList,
  getNewsTypes,
  newsDetails,
  newsList,
  newsCreate,
  newsEdit,
  newsDelete,
  getTypes,
  newsToggle,
  applicationLetterList,
  applicationLetterEdit,
  applicationLetterUpdate,
  applicationLetterTest,
}

export default adminService
